import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: 'aes', isCompression: true });

const i18nService = {
  defaultLanguage: "tr",

  languages: [
    {
      lang: "tr",
      name: "Türkçe",
      flag: process.env.BASE_URL + "media/svg/flags/218-turkey.svg"
    },
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "media/svg/flags/226-united-states.svg"
    },
    {
      lang: "es",
      name: "Español",
      flag: process.env.BASE_URL + "media/svg/flags/128-spain.svg"
    }
  ],


  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    ls.set("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return ls.get("language") || this.defaultLanguage;
  }
};

export default i18nService;
